import { render, staticRenderFns } from "./SolutionEducation.vue?vue&type=template&id=2267bea0&scoped=true&"
import script from "./SolutionEducation.vue?vue&type=script&lang=js&"
export * from "./SolutionEducation.vue?vue&type=script&lang=js&"
import style0 from "./SolutionEducation.vue?vue&type=style&index=0&id=2267bea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267bea0",
  null
  
)

export default component.exports